import {PAGE_ROUTES} from "@/constants/Routes";
import {clearOrgData} from "@/dataStore/organizationStore";
import {store} from "@/dataStore/store";
import {resetUserState} from "@/dataStore/userStore";
import adminApi from "@/services/adminApi";
import authApi from "@/services/authApi";
import campaignApi from "@/services/campaignApi";
import chatApi from "@/services/chatApi";
import instancesApi from "@/services/instancesApi";
import leadsApi from "@/services/leadsApi";
import listBuildingApi from "@/services/listBuildingApi";
import notificationsApi from "@/services/notificationsApi";
import organisationApi from "@/services/organisationApi";

/**
 * Comprehensive logout function that clears all Redux state and caches
 */
export const performLogout = () => {
  const dispatch = store.dispatch;

  // Clear localStorage
  localStorage.clear();

  // Reset custom slices to initial state
  dispatch(resetUserState());
  dispatch(clearOrgData());

  // Clear all RTK Query caches
  dispatch(adminApi.util.resetApiState());
  dispatch(authApi.util.resetApiState());
  dispatch(campaignApi.util.resetApiState());
  dispatch(chatApi.util.resetApiState());
  dispatch(instancesApi.util.resetApiState());
  dispatch(leadsApi.util.resetApiState());
  dispatch(listBuildingApi.util.resetApiState());
  dispatch(notificationsApi.util.resetApiState());
  dispatch(organisationApi.util.resetApiState());

  window.location.href = PAGE_ROUTES.LOGIN;
};
